export default __webpack_public_path__ + "static/media/Star 1.7add387e.svg";